webpackJsonp([143989388479887],{

/***/ 353:
/***/ (function(module, exports) {

	function cubicInOut(t) {
	  return t < 0.5
	    ? 4.0 * t * t * t
	    : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0
	}
	
	module.exports = cubicInOut

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

	/*! npm.im/image-promise 5.0.1 */
	'use strict';
	
	function load(image) {
		if (!image) {
			return Promise.reject();
		} else if (typeof image === 'string') {
			/* Create a <img> from a string */
			var src = image;
			image = new Image();
			image.src = src;
		} else if (image.length !== undefined) {
			/* Treat as multiple images */
	
			// Momentarily ignore errors
			var reflected = [].map.call(image, function (img) { return load(img).catch(function (err) { return err; }); });
	
			return Promise.all(reflected).then(function (results) {
				var loaded = results.filter(function (x) { return x.naturalWidth; });
				if (loaded.length === results.length) {
					return loaded;
				}
				return Promise.reject({
					loaded: loaded,
					errored: results.filter(function (x) { return !x.naturalWidth; })
				});
			});
		} else if (image.tagName !== 'IMG') {
			return Promise.reject();
		}
	
		var promise = new Promise(function (resolve, reject) {
			if (image.naturalWidth) {
				// If the browser can determine the naturalWidth the
				// image is already loaded successfully
				resolve(image);
			} else if (image.complete) {
				// If the image is complete but the naturalWidth is 0px
				// it is probably broken
				reject(image);
			} else {
				image.addEventListener('load', fullfill);
				image.addEventListener('error', fullfill);
			}
			function fullfill() {
				if (image.naturalWidth) {
					resolve(image);
				} else {
					reject(image);
				}
				image.removeEventListener('load', fullfill);
				image.removeEventListener('error', fullfill);
			}
		});
		promise.image = image;
		return promise;
	}
	
	module.exports = load;


/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	        factory(exports, module);
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, mod);
	        global.Impetus = mod.exports;
	    }
	})(this, function (exports, module) {
	    'use strict';
	
	    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	    var stopThresholdDefault = 0.3;
	    var bounceDeceleration = 0.04;
	    var bounceAcceleration = 0.11;
	
	    // fixes weird safari 10 bug where preventDefault is prevented
	    // @see https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
	    window.addEventListener('touchmove', function () {});
	
	    var Impetus = function Impetus(_ref) {
	        var _ref$source = _ref.source;
	        var sourceEl = _ref$source === undefined ? document : _ref$source;
	        var updateCallback = _ref.update;
	        var _ref$multiplier = _ref.multiplier;
	        var multiplier = _ref$multiplier === undefined ? 1 : _ref$multiplier;
	        var _ref$friction = _ref.friction;
	        var friction = _ref$friction === undefined ? 0.92 : _ref$friction;
	        var initialValues = _ref.initialValues;
	        var boundX = _ref.boundX;
	        var boundY = _ref.boundY;
	        var _ref$bounce = _ref.bounce;
	        var bounce = _ref$bounce === undefined ? true : _ref$bounce;
	
	        _classCallCheck(this, Impetus);
	
	        var boundXmin, boundXmax, boundYmin, boundYmax, pointerLastX, pointerLastY, pointerCurrentX, pointerCurrentY, pointerId, decVelX, decVelY;
	        var targetX = 0;
	        var targetY = 0;
	        var stopThreshold = stopThresholdDefault * multiplier;
	        var ticking = false;
	        var pointerActive = false;
	        var paused = false;
	        var decelerating = false;
	        var trackingPoints = [];
	
	        /**
	         * Initialize instance
	         */
	        (function init() {
	            sourceEl = typeof sourceEl === 'string' ? document.querySelector(sourceEl) : sourceEl;
	            if (!sourceEl) {
	                throw new Error('IMPETUS: source not found.');
	            }
	
	            if (!updateCallback) {
	                throw new Error('IMPETUS: update function not defined.');
	            }
	
	            if (initialValues) {
	                if (initialValues[0]) {
	                    targetX = initialValues[0];
	                }
	                if (initialValues[1]) {
	                    targetY = initialValues[1];
	                }
	                callUpdateCallback();
	            }
	
	            // Initialize bound values
	            if (boundX) {
	                boundXmin = boundX[0];
	                boundXmax = boundX[1];
	            }
	            if (boundY) {
	                boundYmin = boundY[0];
	                boundYmax = boundY[1];
	            }
	
	            sourceEl.addEventListener('touchstart', onDown);
	            sourceEl.addEventListener('mousedown', onDown);
	        })();
	
	        /**
	         * In edge cases where you may need to
	         * reinstanciate Impetus on the same sourceEl
	         * this will remove the previous event listeners
	         */
	        this.destroy = function () {
	            sourceEl.removeEventListener('touchstart', onDown);
	            sourceEl.removeEventListener('mousedown', onDown);
	            // however it won't "destroy" a reference
	            // to instance if you'd like to do that
	            // it returns null as a convinience.
	            // ex: `instance = instance.destroy();`
	            return null;
	        };
	
	        /**
	         * Disable movement processing
	         * @public
	         */
	        this.pause = function () {
	            pointerActive = false;
	            paused = true;
	        };
	
	        /**
	         * Enable movement processing
	         * @public
	         */
	        this.resume = function () {
	            paused = false;
	        };
	
	        /**
	         * Update the current x and y values
	         * @public
	         * @param {Number} x
	         * @param {Number} y
	         */
	        this.setValues = function (x, y) {
	            if (typeof x === 'number') {
	                targetX = x;
	            }
	            if (typeof y === 'number') {
	                targetY = y;
	            }
	        };
	
	        /**
	         * Update the multiplier value
	         * @public
	         * @param {Number} val
	         */
	        this.setMultiplier = function (val) {
	            multiplier = val;
	            stopThreshold = stopThresholdDefault * multiplier;
	        };
	
	        /**
	         * Update boundX value
	         * @public
	         * @param {Number[]} boundX
	         */
	        this.setBoundX = function (boundX) {
	            boundXmin = boundX[0];
	            boundXmax = boundX[1];
	        };
	
	        /**
	         * Update boundY value
	         * @public
	         * @param {Number[]} boundY
	         */
	        this.setBoundY = function (boundY) {
	            boundYmin = boundY[0];
	            boundYmax = boundY[1];
	        };
	
	        /**
	         * Executes the update function
	         */
	        function callUpdateCallback() {
	            updateCallback.call(sourceEl, targetX, targetY);
	        }
	
	        /**
	         * Creates a custom normalized event object from touch and mouse events
	         * @param  {Event} ev
	         * @returns {Object} with x, y, and id properties
	         */
	        function normalizeEvent(ev) {
	            if (ev.type === 'touchmove' || ev.type === 'touchstart' || ev.type === 'touchend') {
	                var touch = ev.targetTouches[0] || ev.changedTouches[0];
	                return {
	                    x: touch.clientX,
	                    y: touch.clientY,
	                    id: touch.identifier
	                };
	            } else {
	                // mouse events
	                return {
	                    x: ev.clientX,
	                    y: ev.clientY,
	                    id: null
	                };
	            }
	        }
	
	        /**
	         * Initializes movement tracking
	         * @param  {Object} ev Normalized event
	         */
	        function onDown(ev) {
	            var event = normalizeEvent(ev);
	            if (!pointerActive && !paused) {
	                pointerActive = true;
	                decelerating = false;
	                pointerId = event.id;
	
	                pointerLastX = pointerCurrentX = event.x;
	                pointerLastY = pointerCurrentY = event.y;
	                trackingPoints = [];
	                addTrackingPoint(pointerLastX, pointerLastY);
	
	                // @see https://developers.google.com/web/updates/2017/01/scrolling-intervention
	                document.addEventListener('touchmove', onMove, getPassiveSupported() ? { passive: false } : false);
	                document.addEventListener('touchend', onUp);
	                document.addEventListener('touchcancel', stopTracking);
	                document.addEventListener('mousemove', onMove, getPassiveSupported() ? { passive: false } : false);
	                document.addEventListener('mouseup', onUp);
	            }
	        }
	
	        /**
	         * Handles move events
	         * @param  {Object} ev Normalized event
	         */
	        function onMove(ev) {
	            ev.preventDefault();
	            var event = normalizeEvent(ev);
	
	            if (pointerActive && event.id === pointerId) {
	                pointerCurrentX = event.x;
	                pointerCurrentY = event.y;
	                addTrackingPoint(pointerLastX, pointerLastY);
	                requestTick();
	            }
	        }
	
	        /**
	         * Handles up/end events
	         * @param {Object} ev Normalized event
	         */
	        function onUp(ev) {
	            var event = normalizeEvent(ev);
	
	            if (pointerActive && event.id === pointerId) {
	                stopTracking();
	            }
	        }
	
	        /**
	         * Stops movement tracking, starts animation
	         */
	        function stopTracking() {
	            pointerActive = false;
	            addTrackingPoint(pointerLastX, pointerLastY);
	            startDecelAnim();
	
	            document.removeEventListener('touchmove', onMove);
	            document.removeEventListener('touchend', onUp);
	            document.removeEventListener('touchcancel', stopTracking);
	            document.removeEventListener('mouseup', onUp);
	            document.removeEventListener('mousemove', onMove);
	        }
	
	        /**
	         * Records movement for the last 100ms
	         * @param {number} x
	         * @param {number} y [description]
	         */
	        function addTrackingPoint(x, y) {
	            var time = Date.now();
	            while (trackingPoints.length > 0) {
	                if (time - trackingPoints[0].time <= 100) {
	                    break;
	                }
	                trackingPoints.shift();
	            }
	
	            trackingPoints.push({ x: x, y: y, time: time });
	        }
	
	        /**
	         * Calculate new values, call update function
	         */
	        function updateAndRender() {
	            var pointerChangeX = pointerCurrentX - pointerLastX;
	            var pointerChangeY = pointerCurrentY - pointerLastY;
	
	            targetX += pointerChangeX * multiplier;
	            targetY += pointerChangeY * multiplier;
	
	            if (bounce) {
	                var diff = checkBounds();
	                if (diff.x !== 0) {
	                    targetX -= pointerChangeX * dragOutOfBoundsMultiplier(diff.x) * multiplier;
	                }
	                if (diff.y !== 0) {
	                    targetY -= pointerChangeY * dragOutOfBoundsMultiplier(diff.y) * multiplier;
	                }
	            } else {
	                checkBounds(true);
	            }
	
	            callUpdateCallback();
	
	            pointerLastX = pointerCurrentX;
	            pointerLastY = pointerCurrentY;
	            ticking = false;
	        }
	
	        /**
	         * Returns a value from around 0.5 to 1, based on distance
	         * @param {Number} val
	         */
	        function dragOutOfBoundsMultiplier(val) {
	            return 0.000005 * Math.pow(val, 2) + 0.0001 * val + 0.55;
	        }
	
	        /**
	         * prevents animating faster than current framerate
	         */
	        function requestTick() {
	            if (!ticking) {
	                requestAnimFrame(updateAndRender);
	            }
	            ticking = true;
	        }
	
	        /**
	         * Determine position relative to bounds
	         * @param {Boolean} restrict Whether to restrict target to bounds
	         */
	        function checkBounds(restrict) {
	            var xDiff = 0;
	            var yDiff = 0;
	
	            if (boundXmin !== undefined && targetX < boundXmin) {
	                xDiff = boundXmin - targetX;
	            } else if (boundXmax !== undefined && targetX > boundXmax) {
	                xDiff = boundXmax - targetX;
	            }
	
	            if (boundYmin !== undefined && targetY < boundYmin) {
	                yDiff = boundYmin - targetY;
	            } else if (boundYmax !== undefined && targetY > boundYmax) {
	                yDiff = boundYmax - targetY;
	            }
	
	            if (restrict) {
	                if (xDiff !== 0) {
	                    targetX = xDiff > 0 ? boundXmin : boundXmax;
	                }
	                if (yDiff !== 0) {
	                    targetY = yDiff > 0 ? boundYmin : boundYmax;
	                }
	            }
	
	            return {
	                x: xDiff,
	                y: yDiff,
	                inBounds: xDiff === 0 && yDiff === 0
	            };
	        }
	
	        /**
	         * Initialize animation of values coming to a stop
	         */
	        function startDecelAnim() {
	            var firstPoint = trackingPoints[0];
	            var lastPoint = trackingPoints[trackingPoints.length - 1];
	
	            var xOffset = lastPoint.x - firstPoint.x;
	            var yOffset = lastPoint.y - firstPoint.y;
	            var timeOffset = lastPoint.time - firstPoint.time;
	
	            var D = timeOffset / 15 / multiplier;
	
	            decVelX = xOffset / D || 0; // prevent NaN
	            decVelY = yOffset / D || 0;
	
	            var diff = checkBounds();
	
	            if (Math.abs(decVelX) > 1 || Math.abs(decVelY) > 1 || !diff.inBounds) {
	                decelerating = true;
	                requestAnimFrame(stepDecelAnim);
	            }
	        }
	
	        /**
	         * Animates values slowing down
	         */
	        function stepDecelAnim() {
	            if (!decelerating) {
	                return;
	            }
	
	            decVelX *= friction;
	            decVelY *= friction;
	
	            targetX += decVelX;
	            targetY += decVelY;
	
	            var diff = checkBounds();
	
	            if (Math.abs(decVelX) > stopThreshold || Math.abs(decVelY) > stopThreshold || !diff.inBounds) {
	
	                if (bounce) {
	                    var reboundAdjust = 2.5;
	
	                    if (diff.x !== 0) {
	                        if (diff.x * decVelX <= 0) {
	                            decVelX += diff.x * bounceDeceleration;
	                        } else {
	                            var adjust = diff.x > 0 ? reboundAdjust : -reboundAdjust;
	                            decVelX = (diff.x + adjust) * bounceAcceleration;
	                        }
	                    }
	                    if (diff.y !== 0) {
	                        if (diff.y * decVelY <= 0) {
	                            decVelY += diff.y * bounceDeceleration;
	                        } else {
	                            var adjust = diff.y > 0 ? reboundAdjust : -reboundAdjust;
	                            decVelY = (diff.y + adjust) * bounceAcceleration;
	                        }
	                    }
	                } else {
	                    if (diff.x !== 0) {
	                        if (diff.x > 0) {
	                            targetX = boundXmin;
	                        } else {
	                            targetX = boundXmax;
	                        }
	                        decVelX = 0;
	                    }
	                    if (diff.y !== 0) {
	                        if (diff.y > 0) {
	                            targetY = boundYmin;
	                        } else {
	                            targetY = boundYmax;
	                        }
	                        decVelY = 0;
	                    }
	                }
	
	                callUpdateCallback();
	
	                requestAnimFrame(stepDecelAnim);
	            } else {
	                decelerating = false;
	            }
	        }
	    }
	
	    /**
	     * @see http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	     */
	    ;
	
	    module.exports = Impetus;
	    var requestAnimFrame = (function () {
	        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
	            window.setTimeout(callback, 1000 / 60);
	        };
	    })();
	
	    function getPassiveSupported() {
	        var passiveSupported = false;
	
	        try {
	            var options = Object.defineProperty({}, "passive", {
	                get: function get() {
	                    passiveSupported = true;
	                }
	            });
	
	            window.addEventListener("test", null, options);
	        } catch (err) {}
	
	        getPassiveSupported = function () {
	            return passiveSupported;
	        };
	        return passiveSupported;
	    }
	});


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imagePromise = __webpack_require__(365);
	
	var _imagePromise2 = _interopRequireDefault(_imagePromise);
	
	var _cubicInOut = __webpack_require__(353);
	
	var _cubicInOut2 = _interopRequireDefault(_cubicInOut);
	
	var _animate = __webpack_require__(306);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	var _wait = __webpack_require__(307);
	
	var _wait2 = _interopRequireDefault(_wait);
	
	var _ = __webpack_require__(439);
	
	var _2 = _interopRequireDefault(_);
	
	var _gatsbyImage = __webpack_require__(70);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Impetus = void 0;
	
	if (typeof window !== 'undefined') {
	  Impetus = __webpack_require__(367);
	}
	
	var ThreeSixtCatalog = function (_React$Component) {
	  _inherits(ThreeSixtCatalog, _React$Component);
	
	  function ThreeSixtCatalog(props) {
	    _classCallCheck(this, ThreeSixtCatalog);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      current: 7,
	      loading: true,
	      hasSpinned: false,
	      isHovered: false,
	      frames: []
	    };
	    return _this;
	  }
	
	  ThreeSixtCatalog.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (typeof window === 'undefined') {
	      return;
	    }
	    this._ismounted = true;
	
	    var _props = this.props,
	        product = _props.product,
	        timeout = _props.timeout;
	    var collection = product.collection;
	
	    var frames = collection.threesixty.frames;
	
	    var firstFrameSrc = frames[0].normal.src;
	    var adjustedFrames = firstFrameSrc.includes("_01") ? collection.threesixty.frames.reverse() : collection.threesixty.frames;
	
	    var selectedFrames = adjustedFrames.map(function (f) {
	      return f[collection.threesixty.isTall ? 'tall' : 'normal'].src;
	    });
	
	    this.setState({ frames: selectedFrames });
	
	    Promise.all([(0, _wait2.default)(timeout), (0, _imagePromise2.default)(selectedFrames).then(function () {
	      _this2.setState({ loading: false });
	    }).catch(function (errr) {
	      return console.error(errr);
	    })]);
	  };
	
	  ThreeSixtCatalog.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._ismounted = false;
	  };
	
	  ThreeSixtCatalog.prototype.onMouseEnterHandler = function onMouseEnterHandler() {
	    var _this3 = this;
	
	    if (!this.state.loading && !this.state.hasSpinned) {
	      (0, _wait2.default)(100).then(function () {
	        (0, _animate2.default)(7, 57, 2000, _cubicInOut2.default, function (frame) {
	          _this3.setCurrentFrame(Math.floor(frame));
	        });
	      }).then(function () {
	        _this3.setState({ hasSpinned: true });
	      }).catch(function (errr) {
	        return console.error(errr);
	      });
	    }
	  };
	
	  ThreeSixtCatalog.prototype.handleHover = function handleHover() {
	    this.setState({
	      isHovered: !this.state.isHovered
	    });
	  };
	
	  ThreeSixtCatalog.prototype.setCurrentFrame = function setCurrentFrame(frame) {
	    var collection = this.props.collection;
	    var frames = this.state.frames;
	
	
	    var length = frames.length;
	    var current = frame;
	
	    while (current < 0) {
	      current = current + length;
	    }
	
	    while (current > length - 1) {
	      current = current - length;
	    }
	
	    if (current !== this.state.current) {
	      this.setState({ current: current });
	    }
	  };
	
	  ThreeSixtCatalog.prototype.render = function render() {
	    var _this4 = this;
	
	    var product = this.props.product;
	    var collection = product.collection;
	    var _state = this.state,
	        loading = _state.loading,
	        current = _state.current,
	        isHovered = _state.isHovered,
	        frames = _state.frames;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'catalog__item', key: collection.color.hex,
	        style: { backgroundColor: '' + (isHovered ? collection.color.hex : 'transparent') }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'catalog__item__title' },
	        product.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'threesixty--catalog',
	          ref: function ref(el) {
	            return _this4.container = el;
	          },
	          onMouseEnter: function onMouseEnter() {
	            _this4.onMouseEnterHandler();
	            _this4.handleHover();
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this4.handleHover();
	          }
	        },
	        product.showThreesixty ? _react2.default.createElement(
	          'div',
	          null,
	          frames.map(function (frame, i) {
	            return _react2.default.createElement('img', { className: 'threesixty--catalog__image ' + (i === current ? "" : "hidden"),
	              src: frame, key: i
	            });
	          }),
	          loading && _react2.default.createElement(
	            'div',
	            { className: 'threesixty__loading' },
	            _react2.default.createElement('div', { className: 'threesixty__loading__rect1' }),
	            _react2.default.createElement('div', { className: 'threesixty__loading__rect2' }),
	            _react2.default.createElement('div', { className: 'threesixty__loading__rect3' }),
	            _react2.default.createElement('div', { className: 'threesixty__loading__rect4' }),
	            _react2.default.createElement('div', { className: 'threesixty__loading__rect5' })
	          )
	        ) : _react2.default.createElement('img', { src: product.image.sizes.src, key: product.image.src })
	      )
	    );
	  };
	
	  return ThreeSixtCatalog;
	}(_react2.default.Component);
	
	exports.default = ThreeSixtCatalog;
	module.exports = exports['default'];

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+MzYwPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjI2LjAwMDAwMCwgLTE0NTUuMDAwMDAwKSI+CiAgICAgICAgPHBhdGggZD0iTTM3NS42NzQyMDMsMTcwOC43NzU1NCBDMzg3LjQ0MTY5MiwxNzEzLjExMDkzIDM5NC4wNDgwMDIsMTcyNi4xMTcxIDM5NC4wNDgwMDIsMTczOS4zMjk3MiBDMzk0LjA0ODAwMiwxNzYxLjQxOTU3IDM3NS4yNjEzMDksMTc3OS45OTk4MSAzNDkuNDU1NDEyLDE3NzkuOTk5ODEgQzMyMS43OTE0OSwxNzc5Ljk5OTgxIDMwMy40MTc2OTEsMTc1OC4zMjI4NiAzMDMuNDE3NjkxLDE3MzcuODg0NTkgTDMzMC4wNDkzNzcsMTczNy44ODQ1OSBDMzMwLjg3NTE2NiwxNzQ1LjkzNjAzIDMzNy4wNjg1ODEsMTc1NC4xOTM5MiAzNDkuMDQyNTE3LDE3NTQuMTkzOTIgQzM1OC43NDU1MzUsMTc1NC4xOTM5MiAzNjYuNzk2OTc1LDE3NDguODI2MjkgMzY2Ljc5Njk3NSwxNzM3Ljg4NDU5IEMzNjYuNzk2OTc1LDE3MjkuMjEzODEgMzYxLjYzNTc5NSwxNzE5LjcxNzI0IDM0Ni4zNTg3MDQsMTcxOS43MTcyNCBMMzM3LjQ4MTQ3NiwxNzE5LjcxNzI0IEwzMzcuNDgxNDc2LDE2OTguMDQwMjggTDM0NS41MzI5MTUsMTY5OC4wNDAyOCBDMzYwLjE5MDY2NSwxNjk4LjA0MDI4IDM2My4wODA5MjYsMTY4OC41NDM3MSAzNjMuMDgwOTI2LDE2ODIuOTY5NjQgQzM2My4wODA5MjYsMTY3NC4wOTI0MSAzNTUuODU1Mjc0LDE2NjkuNTUwNTcgMzQ4LjQyMzE3NiwxNjY5LjU1MDU3IEMzNDMuNDY4NDQ0LDE2NjkuNTUwNTcgMzM1LjQxNzAwNCwxNjcxLjYxNTA0IDMzNC4xNzgzMjEsMTY4MS45Mzc0IEwzMDguMTY1OTc2LDE2ODEuOTM3NCBDMzA4LjE2NTk3NiwxNjU5Ljg0NzU2IDMyNy43Nzg0NTgsMTY0NS42MDI3IDM0OS40NTU0MTIsMTY0NS42MDI3IEMzNzAuNzE5NDcxLDE2NDUuNjAyNyAzODkuMDkzMjcsMTY1OS42NDExMSAzODkuMDkzMjcsMTY4MC40OTIyNyBDMzg5LjA5MzI3LDE2OTEuNDMzOTcgMzg0LjEzODUzOCwxNzAyLjM3NTY3IDM3NS42NzQyMDMsMTcwNy4xMjM5NiBMMzc1LjY3NDIwMywxNzA4Ljc3NTU0IFogTTQ1NC45NDIyNzQsMTY5NC45NDM1OCBDNDc5LjkyMjM4MiwxNjk0Ljk0MzU4IDQ5OS4xMjE5NywxNzExLjI1MjkgNDk5LjEyMTk3LDE3MzYuODUyMzUgQzQ5OS4xMjE5NywxNzY0LjEwMzM4IDQ3Ny42NTE0NjMsMTc3OS45OTk4MSA0NTQuNzM1ODI3LDE3NzkuOTk5ODEgQzQzMi4wMjY2MzcsMTc3OS45OTk4MSA0MTAuMzQ5Njg0LDE3NjQuNTE2MjcgNDEwLjM0OTY4NCwxNzM2LjY0NTkgQzQxMC4zNDk2ODQsMTcyNy45NzUxMiA0MTIuNDE0MTU1LDE3MjEuMTYyMzcgNDE0LjI3MjE4LDE3MTUuMTc1NCBDNDE4LjYwNzU3MSwxNzAxLjM0MzQ0IDQ0My41ODc2NzksMTY2Mi41MzEzNyA0NTMuMDg0MjQ5LDE2NDYuNjM0OTQgTDQ4My4wMTkwOSwxNjQ2LjYzNDk0IEw0NTQuOTQyMjc0LDE2OTQuOTQzNTggWiBNNDU0LjczNTgyNywxNzU0LjYwNjgxIEM0NjMuMjAwMTYxLDE3NTQuNjA2ODEgNDcyLjQ5MDI4NCwxNzQ5LjY1MjA4IDQ3Mi40OTAyODQsMTczNi44NTIzNSBDNDcyLjQ5MDI4NCwxNzIzLjQzMzI5IDQ2MS45NjE0NzgsMTcxOS4zMDQzNCA0NTQuNzM1ODI3LDE3MTkuMzA0MzQgQzQ0Ny41MTAxNzUsMTcxOS4zMDQzNCA0MzYuOTgxMzY5LDE3MjMuNDMzMjkgNDM2Ljk4MTM2OSwxNzM2Ljg1MjM1IEM0MzYuOTgxMzY5LDE3NDkuNjUyMDggNDQ2LjQ3Nzk0LDE3NTQuNjA2ODEgNDU0LjczNTgyNywxNzU0LjYwNjgxIFogTTU1OS4xOTA0NTMsMTc3OS45OTk4MSBDNTI2LjM2NTM1MiwxNzc5Ljk5OTgxIDUwOS4wMjM3ODksMTc1NS4wMTk3IDUwOS4wMjM3ODksMTcxMi42OTgwMyBDNTA5LjAyMzc4OSwxNjcwLjM3NjM2IDUyNi4zNjUzNTIsMTY0NS42MDI3IDU1OC45ODQwMDYsMTY0NS42MDI3IEM1OTEuNjAyNjU5LDE2NDUuNjAyNyA2MDguOTQ0MjIyLDE2NzAuMzc2MzYgNjA4Ljk0NDIyMiwxNzEyLjkwNDQ4IEM2MDguOTQ0MjIyLDE3NTUuMjI2MTUgNTkxLjgwOTEwNywxNzc5Ljk5OTgxIDU1OS4xOTA0NTMsMTc3OS45OTk4MSBaIE01NTguOTg0MDA2LDE3NTIuNTQyMzQgQzU3Ni45NDQ5MSwxNzUyLjU0MjM0IDU3OS44MzUxNywxNzMwLjAzOTYgNTc5LjgzNTE3LDE3MTMuMTEwOTMgQzU3OS44MzUxNywxNjk1LjU2MjkyIDU3Ni43Mzg0NjMsMTY3My4wNjAxNyA1NTguOTg0MDA2LDE2NzMuMDYwMTcgQzU0MS40MzU5OTUsMTY3My4wNjAxNyA1MzguMzM5Mjg4LDE2OTUuNTYyOTIgNTM4LjMzOTI4OCwxNzEyLjkwNDQ4IEM1MzguMzM5Mjg4LDE3MzAuNDUyNDkgNTQxLjQzNTk5NSwxNzUyLjU0MjM0IDU1OC45ODQwMDYsMTc1Mi41NDIzNCBaIE02NDAuNTIyOTk1LDE2OTUuOTc1ODEgQzYyNi40ODQ1ODcsMTY5NS45NzU4MSA2MTUuMTI5OTkyLDE2ODQuNjIxMjIgNjE1LjEyOTk5MiwxNjcwLjU4MjgxIEM2MTUuMTI5OTkyLDE2NTYuNTQ0NCA2MjYuNDg0NTg3LDE2NDUuMTg5ODEgNjQwLjUyMjk5NSwxNjQ1LjE4OTgxIEM2NTQuMzU0OTU2LDE2NDUuMTg5ODEgNjY1LjkxNTk5OCwxNjU2LjU0NDQgNjY1LjkxNTk5OCwxNjcwLjU4MjgxIEM2NjUuOTE1OTk4LDE2ODQuNjIxMjIgNjU0LjM1NDk1NiwxNjk1Ljk3NTgxIDY0MC41MjI5OTUsMTY5NS45NzU4MSBaIE02NDAuNTIyOTk1LDE2NzcuODA4NDYgQzY0NC42NTE5MzksMTY3Ny44MDg0NiA2NDcuNzQ4NjQ2LDE2NzQuNzExNzUgNjQ3Ljc0ODY0NiwxNjcwLjU4MjgxIEM2NDcuNzQ4NjQ2LDE2NjYuNDUzODYgNjQ0LjY1MTkzOSwxNjYzLjM1NzE2IDY0MC41MjI5OTUsMTY2My4zNTcxNiBDNjM2LjM5NDA1MSwxNjYzLjM1NzE2IDYzMy4yOTczNDQsMTY2Ni40NTM4NiA2MzMuMjk3MzQ0LDE2NzAuNTgyODEgQzYzMy4yOTczNDQsMTY3NC43MTE3NSA2MzYuMzk0MDUxLDE2NzcuODA4NDYgNjQwLjUyMjk5NSwxNjc3LjgwODQ2IFogTTYzMS41Mzg5NDUsMTUyOC44OTc0IEw2MjAuMjUwODYyLDE1ODQuNDYzMTQgTDU4OC42MzkxOSwxNTc4LjA0MTI4IEw2MTAuMzg0NDQxLDE0NzEgTDcxOS4yNzI5MywxNDc5LjYwMTcgTDcxNi43MzI2NTYsMTUxMS43NTg4OSBMNjU1LjI5ODE4NCwxNTA2LjkwNTg1IEM2NjguNzc1Mjk2LDE1MTkuMzIxMDQgNjgwLjk3MzUyNCwxNTMzLjI0OTUxIDY5MS42ODQ5NDUsMTU0OC41NDcgQzc3Mi43NzMwMzcsMTY2NC4zNTI4IDc0NC42Mjg3NzYsMTgyMy45NjY4MyA2MjguODIyOTc5LDE5MDUuMDU0OTMgQzUxMy4wMTcxODIsMTk4Ni4xNDMwMiAzNTMuNDAzMTQ3LDE5NTcuOTk4NzYgMjcyLjMxNTA1NSwxODQyLjE5Mjk2IEMxOTEuMjI2OTYzLDE3MjYuMzg3MTYgMjE5LjM3MTIyNCwxNTY2Ljc3MzEzIDMzNS4xNzcwMjEsMTQ4NS42ODUwNCBMMzUzLjY3OTA4OSwxNTEyLjEwODczIEMyNTIuNDY2Njk0LDE1ODIuOTc4NDEgMjI3Ljg2OTA2NSwxNzIyLjQ3ODUgMjk4LjczODc0NywxODIzLjY5MDg5IEMzNjkuNjA4NDI5LDE5MjQuOTAzMjkgNTA5LjEwODUxNiwxOTQ5LjUwMDkyIDYxMC4zMjA5MTEsMTg3OC42MzEyMyBDNzExLjUzMzMwNiwxODA3Ljc2MTU1IDczNi4xMzA5MzUsMTY2OC4yNjE0NyA2NjUuMjYxMjUzLDE1NjcuMDQ5MDcgQzY1NS4zODM3NzgsMTU1Mi45NDI1NyA2NDQuMDc0MDgxLDE1NDAuMTc5MDcgNjMxLjUzODk0NSwxNTI4Ljg5NzQgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getTransitionStyle = __webpack_require__(30);
	
	var _getTransitionStyle2 = _interopRequireDefault(_getTransitionStyle);
	
	var _Footer = __webpack_require__(58);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Menu = __webpack_require__(52);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _IntlLink = __webpack_require__(23);
	
	var _IntlLink2 = _interopRequireDefault(_IntlLink);
	
	var _PageAnimations = __webpack_require__(59);
	
	var _PageAnimations2 = _interopRequireDefault(_PageAnimations);
	
	var _gatsbySourceDatocms = __webpack_require__(80);
	
	var _ThreeSixtyCatalog = __webpack_require__(603);
	
	var _ThreeSixtyCatalog2 = _interopRequireDefault(_ThreeSixtyCatalog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Catalog = function (_React$Component) {
	  _inherits(Catalog, _React$Component);
	
	  function Catalog() {
	    _classCallCheck(this, Catalog);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Catalog.prototype.renderCustomProduct = function renderCustomProduct(product, i) {
	    var collection = product.collection,
	        image = product.image;
	
	    return _react2.default.createElement(
	      _IntlLink2.default,
	      {
	        to: '/collection/' + collection.slug,
	        key: i
	      },
	      _react2.default.createElement(_ThreeSixtyCatalog2.default, {
	        timeout: 3500,
	        product: product
	      })
	    );
	  };
	
	  Catalog.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	
	
	    var status = this.props.transition ? this.props.transition.status : "entering";
	    var menuStyle = (0, _getTransitionStyle2.default)(status, 200, 2000, 'menuStyle');
	    var timeout = 800;
	    var delay = 1000;
	
	    var sectionAppears = (0, _getTransitionStyle2.default)(status, timeout, 1000, 'pageAppearsFromBottom');
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'page',
	        style: { backgroundColor: data.catalog.themeColor.hex }
	      },
	      _react2.default.createElement(_gatsbySourceDatocms.HelmetDatoCms, {
	        seo: data.catalog.seo,
	        favicon: data.site.favicon
	      }),
	      _react2.default.createElement(_Menu2.default, {
	        style: menuStyle,
	        hasWhiteLogo: false,
	        data: data
	      }),
	      _react2.default.createElement(_PageAnimations2.default, {
	        status: status,
	        timeout: timeout,
	        delay: timeout,
	        color: data.catalog.themeColor.hex
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'page__wrapper', style: sectionAppears },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page__title--dark' },
	          data.catalog.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'catalog' },
	            data.catalog.products.map(function (product, i) {
	              return _this2.renderCustomProduct(product, i);
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, { data: this.props.data })
	    );
	  };
	
	  return Catalog;
	}(_react2.default.Component);
	
	exports.default = Catalog;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var animate = function animate(start, end, duration, easing, cb) {
	  return new Promise(function (resolve, reject) {
	    var begin = Date.now();
	    var update = function update() {
	      var now = Date.now();
	      var t = (now - begin) / duration;
	      var v = easing(t);
	      var v2 = start + v * (end - start);
	      cb(v2);
	      if (t < 1) {
	        requestAnimationFrame(update);
	      } else {
	        resolve();
	      }
	    };
	    requestAnimationFrame(update);
	  });
	};
	
	exports.default = animate;
	module.exports = exports["default"];

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var wait = function wait(duration) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, duration);
	  });
	};
	
	exports.default = wait;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-catalog-js-5e3c4e8cee1abd2a6bc9.js